

<div *ngIf="adminApi.showLoader" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>